import React from 'react';

import classNames from 'classnames';

export interface IReactionProps {
    type?: TReactionType;
    direction?: TThumbDirection;
    className?: string;
}

export type TReactionType = 'thumb' | 'talk-bubble';
export type TThumbDirection = 'up' | 'down';


const Reaction = ({ type = 'thumb', direction = 'up', className }: IReactionProps): JSX.Element => {
    const computedClassName: string = classNames(
        'thumb',
        {
            [`thumb--direction-${direction}`]: type === 'thumb' && !!direction,
        },
        className,
    );

    return (
        <div className={computedClassName}>
            <span className={type === 'talk-bubble' ? 'chat-icon' : 'thumb__icon'} />
        </div>
    );
};

export default Reaction;

